module.exports = __webpack_public_path__ + "static/media/tutorial-photos-pin.54b07526.svg";